// src/hooks/usePrefersReducedMotion.ts
import { useEffect, useState } from "react";
var QUERY = "(prefers-reduced-motion: reduce)";
var readPreference = () => {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  try {
    return window.matchMedia(QUERY).matches;
  } catch {
    return false;
  }
};
function usePrefersReducedMotion() {
  const [reduce, setReduce] = useState(readPreference);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    let mq;
    try {
      mq = window.matchMedia(QUERY);
    } catch {
      return;
    }
    const update = () => setReduce(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return reduce;
}

export {
  usePrefersReducedMotion
};
//# sourceMappingURL=chunk-XK4WW6FW.mjs.map